import React, { FC } from 'react';

export interface ViewDocumentProps {
  handleDocument: () => void;
  disabled?: boolean;
}

export const UploadDocument: FC<ViewDocumentProps> = ({ handleDocument, disabled }) => {
  return (
    <div className="tag-ds ">
      <button className="button-secondary" onClick={handleDocument} disabled={disabled}>
        <span className="material-icons">upload</span>
      </button>
    </div>
  );
};
